(function() {
  function initPromoPerksSection(container) {
    if (!container || container.dataset.initialized === "true") return;
    
    const grid = container.querySelector('.js-perks-grid');
    const arrow = container.querySelector('.js-perks-arrow');
    const items = container.querySelectorAll('.js-perk-item');
    const mobileLayout = container.dataset.mobileLayout;
    const enableAutoRotate = container.dataset.autorotate === 'true';
    const rotateSpeed = parseInt(container.dataset.speed || 4, 10) * 1000;
    
    let timer = null;

    // Do not run slider JavaScript if mobile layout is set to stacked
    if (!grid || items.length <= 1 || mobileLayout === 'stacked') return;

    function nextSlide() {
      const slideWidth = grid.clientWidth;
      const currentScroll = grid.scrollLeft;
      const maxScroll = grid.scrollWidth - slideWidth;

      if (Math.ceil(currentScroll) >= maxScroll - 10) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        const nextTarget = Math.round((currentScroll + slideWidth) / slideWidth) * slideWidth;
        grid.scrollTo({ left: nextTarget, behavior: 'smooth' });
      }
    }

    function startTimer() {
      if (window.innerWidth >= 750 || !enableAutoRotate) return;
      stopTimer();
      timer = setInterval(nextSlide, rotateSpeed);
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function resetTimer() {
      stopTimer();
      startTimer();
    }

    if (arrow) {
      arrow.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        nextSlide();
        resetTimer();
      });
    }

    if (enableAutoRotate) {
      startTimer();
      container.addEventListener('mouseenter', stopTimer);
      container.addEventListener('mouseleave', startTimer);
      container.addEventListener('touchstart', stopTimer, { passive: true });
      container.addEventListener('touchend', startTimer, { passive: true });
    }

    container.dataset.initialized = "true";
  }

  // Initialize all section instances on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.js-promo-perks-instance').forEach(initPromoPerksSection);
  });

  // Re-initialize for dynamic updates or theme customizer
  document.querySelectorAll('.js-promo-perks-instance').forEach(initPromoPerksSection);

  document.addEventListener('shopify:section:load', function(e) {
    const sectionContainer = e.target.querySelector('.js-promo-perks-instance');
    if (sectionContainer) {
      initPromoPerksSection(sectionContainer);
    }
  });
})();